import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Select, Button as ButtonUI } from 'components/UI';
import { Input } from 'antd';
import confirm from 'theme/icon/confirm.png';
import cancel from 'theme/icon/cancel.png';
import _ from 'lodash';
import Button from '../../control/button';
import styles from './styles.scss';

const { TextArea } = Input;

const getInitialValue = values => {
  let newValues = _.cloneDeep(values);
  newValues = newValues || {};
  return newValues;
};

const getChildOptions = (id, options) => {
  const element = options.find(el => el.id === id);
  return (element || {}).children || [];
};

const SelectAttribute = props => {
  const [value, setValue] = useState(getInitialValue(props.item.value));
  const [childOptions, setChildOptions] = useState(
    value && value.parent ? getChildOptions(value.parent.value, props.item.options) : [],
  );
  useEffect(() => {
    setValue(getInitialValue(props.item.value));
  }, [props.item.value]);
  const isCommentEnable = (id, arr = props.item.options) => {
    let isEnable = false;
    for (let i = 0; i < arr.length; i += 1) {
      if (arr[i].id === id && arr[i].isComment) {
        isEnable = true;
        break;
      }

      if (arr[i].children) {
        isEnable = isCommentEnable(id, arr[i].children);
      }
    }
    return isEnable;
  };

  const { isShowSave, isShowCancel } = props;
  return (
    <div className={styles.select}>
      {props.item.parentId && (
        <div className={styles.header}>
          <ButtonUI color="transparent" onClick={props.default.onBack}>
            {'< Назад'}
          </ButtonUI>
          <h5>{props.item.name}</h5>
        </div>
      )}
      <div className={styles.top}>
        <div className={styles.option}>
          <Select
            placeholder="Выберите опцию"
            options={props.item.options}
            value={_.get(value, 'parent.value') || null}
            labelKey="name"
            valueKey="id"
            onChange={e => {
              if (e !== _.get(value, 'parent.value')) {
                const parent = props.item.options.find(el => el.id === e);
                setChildOptions(parent.children || []);
                const newItem = {
                  parent: { value: e, comment: '' },
                };

                setValue(newItem);
                props.onChange(newItem);
              }
            }}
            style={{ width: 324 }}
          />
          {isCommentEnable(_.get(value, 'parent.value')) && (
            <div className={styles.comment}>
              <TextArea
                value={value.parent.comment}
                placeholder="Комментарий"
                onChange={e => {
                  if (e.target.value.length <= 200) {
                    const newItem = {
                      ...value,
                      parent: { ...value.parent, comment: e.target.value },
                    };
                    setValue(newItem);
                    props.onChange(newItem);
                  }
                }}
                autosize={{ minRows: 4, maxRows: 4 }}
              />
            </div>
          )}
        </div>
        <div className={styles.option}>
          {_.get(value, 'parent.value') && childOptions.length > 0 && (
            <Select
              placeholder="Выберите опцию"
              options={childOptions}
              value={_.get(value, 'child.value') || null}
              labelKey="name"
              valueKey="id"
              onChange={e => {
                if (e !== _.get(value, 'child.value')) {
                  const newItem = {
                    ...value,
                    child: { value: e, comment: '' },
                  };
                  setValue(newItem);
                  props.onChange(newItem);
                }
              }}
              style={{ width: 324 }}
            />
          )}
          {isCommentEnable(_.get(value, 'child.value') ? value.child.value : null) && (
            <div className={styles.comment}>
              <TextArea
                value={value.child.comment}
                placeholder="Комментарий"
                onChange={e => {
                  if (e.target.value.length <= 200) {
                    const newItem = {
                      ...value,
                      child: { ...value.child, comment: e.target.value },
                    };
                    setValue(newItem);
                    props.onChange(newItem);
                  }
                }}
                autosize={{ minRows: 4, maxRows: 4 }}
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles.bottom}>
        {props.isShowButtons && (
          <div className={styles.buttons}>
            <Button className={styles.save} isShow={isShowSave} img={confirm} onAction={props.onSave} />
            <Button className={styles.cancel} isShow={isShowCancel} img={cancel} onAction={props.onCancel} />
          </div>
        )}
      </div>
    </div>
  );
};

SelectAttribute.propTypes = {
  isShowButtons: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.objectOf(PropTypes.any),
  onChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  onCancel: PropTypes.func,
  name: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  default: PropTypes.objectOf(PropTypes.any).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  isShowSave: PropTypes.bool,
  isShowCancel: PropTypes.bool,
};

SelectAttribute.defaultProps = {
  isShowButtons: true,
  value: null,
  isShowSave: true,
  isShowCancel: true,
  onCancel: () => {},
  onSave: () => {},
};

export default SelectAttribute;
